import React from 'react';
import { Carousel } from 'react-bootstrap';

export const CarouselBannersHome = ({ data }) => {
  return (
    <React.Fragment>
      <Carousel>
        {data?.map((item) => (
          <Carousel.Item key={item?._id}>
            {item?.urlRedireccion ? (
              <a href={item.urlRedireccion} target="_blank">
                <img
                  className="d-block w-100"
                  src={item?.banner_url}
                  style={{ maxHeight: '10rem' }}
                  alt={item?.banner_url}
                />
                <Carousel.Caption>
                  <h2 className="text-carrousel">{item?.titulo}</h2>
                  <p className="text-carrousel-dt">{item?.descripcion}</p>
                </Carousel.Caption>
              </a>
            ) : (
              <div>
                <img
                  className="d-block w-100"
                  src={item?.banner_url}
                  style={{ maxHeight: '10rem' }}
                  alt={item?.banner_url}
                />
                <Carousel.Caption>
                  <h2 className="text-carrousel">{item?.titulo}</h2>
                  <p className="text-carrousel-dt">{item?.descripcion}</p>
                </Carousel.Caption>
              </div>
            )}
          </Carousel.Item>
        ))}
      </Carousel>
    </React.Fragment>
  );
};

export default CarouselBannersHome;
